import { useTranslation } from 'react-i18next';
import { formatDate } from '~/utils';
import type { Quote } from './splitAwardGridTypes';

type ReadyToShipQuote = Pick<Quote, 'id' | 'submittedAt' | 'leadTimeDays'>;

function readyToShipIso(quote: ReadyToShipQuote): string | null {
  if (!quote.submittedAt || quote.leadTimeDays == null) return null;
  const readyDate = new Date(quote.submittedAt);
  readyDate.setDate(readyDate.getDate() + quote.leadTimeDays);
  return readyDate.toISOString();
}

export function QuoteReadyToShip({
  quote,
}: Readonly<{ quote: ReadyToShipQuote }>) {
  const { t } = useTranslation('rfq-view');
  const readyToShip = readyToShipIso(quote);

  return (
    <p
      className="mt-1 text-sm font-normal text-neut-prim"
      data-testid={`ready-to-ship-${quote.id}`}
    >
      <span className="font-semibold">
        {t('rfq_view.ready_to_ship_date_label')}:
      </span>{' '}
      {readyToShip ? formatDate(readyToShip) : '—'}
    </p>
  );
}
